import { render, staticRenderFns } from "./doc_handle.vue?vue&type=template&id=5ab27ec3&scoped=true"
import script from "./doc_handle.vue?vue&type=script&lang=js"
export * from "./doc_handle.vue?vue&type=script&lang=js"
import style0 from "./doc_handle.vue?vue&type=style&index=0&id=5ab27ec3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab27ec3",
  null
  
)

export default component.exports